import type { AiMediaSettings } from './types';

export type AiSettingsDraft = Omit<AiMediaSettings, 'hasApiKey' | 'transportRisk'> & { apiKey: string; clearApiKey: boolean };

export function aiSettingsDraft(saved: AiMediaSettings): AiSettingsDraft {
  const { hasApiKey: _key, transportRisk: _risk, ...values } = saved;
  return { ...values, apiKey: '', clearApiKey: false };
}

export function aiSettingsError(draft: AiSettingsDraft): string {
  if (draft.endpoint.trim() && !draft.textModel.trim()) return '请在文字生成中选择在线文字模型';
  if (draft.endpoint.trim() && !draft.imageModel.trim()) return '请在图像生成中选择主模型';
  if (draft.imageFallbackEnabled) {
    if (!draft.imageFallbackModel.trim()) return '请在图像生成中选择备用模型，或关闭自动切换';
    if (draft.imageFallbackModel.trim() === draft.imageModel.trim()) return '图像主模型和备用模型需要不同';
  }
  return '';
}

export function isPublicHttpEndpoint(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' && !['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname.toLowerCase());
  } catch { return false; }
}

export function aiModelOptions(models: string[], current: string[], kind: 'text' | 'image') {
  const isImage = (value: string) => /image|imagen|dall-e|flux|stable-diffusion/i.test(value);
  const matching = models.filter(value => kind === 'image' ? isImage(value) : !isImage(value));
  return [...new Set([...current.filter(Boolean), ...matching])].map(value => ({ value }));
}
